/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EmailReportConfiguration {
    getFixupPrototypeFunction() { return EmailReportConfiguration.fixupPrototype; }

    static newInstance(model: Partial<EmailReportConfiguration>): EmailReportConfiguration {
        let obj = Object.assign(new EmailReportConfiguration(), model);
        EmailReportConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EmailReportConfiguration>): EmailReportConfiguration {
        if (!model) return null;
        return EmailReportConfiguration.newInstance(<EmailReportConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EmailReportConfiguration) {
        if (!obj) return;

        models.EmailReportConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EmailReportConfiguration): boolean {
        Object.setPrototypeOf(obj, EmailReportConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.daily_cost_summary_report) {
            models.EmailReportEntry.fixupPrototype(this.daily_cost_summary_report);
        }
        if (this.daily_governance_report) {
            models.EmailReportEntry.fixupPrototype(this.daily_governance_report);
        }
        if (this.daily_inventory_monitoring_report) {
            models.EmailReportEntry.fixupPrototype(this.daily_inventory_monitoring_report);
        }
        if (this.monthly_cost_summary_report) {
            models.EmailReportEntry.fixupPrototype(this.monthly_cost_summary_report);
        }
        if (this.daily_cloud_impact_report) {
            models.EmailReportEntry.fixupPrototype(this.daily_cloud_impact_report);
        }
    }

    /**
     * Use common email for all reports
     */
    common_email: boolean;

    /**
     * Common email addresses for reports
     */
    email_address: Array<string>;

    /**
     * Daily cost summary report settings
     */
    daily_cost_summary_report: models.EmailReportEntry;

    /**
     * Daily governance report settings
     */
    daily_governance_report: models.EmailReportEntry;

    /**
     * Daily inventory monitoring report settings
     */
    daily_inventory_monitoring_report: models.EmailReportEntry;

    /**
     * Monthly cost summary report settings
     */
    monthly_cost_summary_report: models.EmailReportEntry;

    /**
     * Daily cloud impact report settings
     */
    daily_cloud_impact_report: models.EmailReportEntry;

}
